import { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";

const fontFamilyProperty = '--font-family'

export const useCustomTheme = () => {
  const languageCodes = ["ITA", "FRA", "DEU", "ESP", "PRT"];
  const [searchParam] = useSearchParams();

  useEffect(() => {
    if (location.pathname.search(/(ford|partplus)/) === -1) {
      return undefined;
    }

    const targetNode = document.getElementById("root");
    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: true };
    const callback = (mutationList: any) => {
      for (const mutation of mutationList) {
        if (mutation?.addedNodes[0]?.classList?.contains("abs-modal")) {
          (
            mutation?.addedNodes[0].firstChild.firstChild as HTMLElement
          )?.style?.removeProperty(fontFamilyProperty);
        }
      }
    };
    const observer = new MutationObserver(callback);

    if (targetNode) {
      observer.observe(targetNode, config);
    }

    (
      document.querySelector("#oil-search") as HTMLElement
    )?.style?.removeProperty(fontFamilyProperty);
    
    (
      document.querySelector(".wtb-outlet") as HTMLElement
    )?.style?.removeProperty(fontFamilyProperty);

    const languageCode = searchParam.get("languageCode");

    if (
      languageCode &&
      languageCodes.includes(languageCode) &&
      localStorage.getItem("countryCode")?.toLowerCase() !==
        languageCode.toLowerCase()
    ) {
      if (languageCode.toLowerCase() === "esp") {
        localStorage.setItem("countryCode", "ESP");
        localStorage.setItem("languageCode", "SPA");
      } else {
        localStorage.setItem("countryCode", languageCode.toUpperCase());
        localStorage.setItem("languageCode", languageCode.toUpperCase());
      }
      window.location.reload();
    } else if (
      localStorage.getItem("countryCode")?.toLowerCase() !==
      languageCode?.toLowerCase()
    ) {
      localStorage.setItem("languageCode", "ENG");
      localStorage.setItem("countryCode", "GBR");
    }

    return function () {
      return observer?.disconnect();
    };
  }, []);
  return null;
};

